import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config";

export default function ProtectDashboardRoute() {
  const navigate = useNavigate();

  useEffect(() => {
    const verifyUser = async () => {
      // 🚀 Step 1: Get the token from local storage
      const token = localStorage.getItem("authToken");

      if (!token) {
        // No token found, user is definitely not logged in.
        return navigate("/login");
      }

      try {
        // 🚀 Step 2: Send the request with the Authorization header
        // Note: Using 'fetch' here but you could use 'axios' if you prefer consistency.
        const res = await fetch(`${config.API_BASE_URL}/api/auth/profile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Send the Bearer token
            Authorization: `Bearer ${token}`,
            // ❌ Removed 'credentials: "include"' as it's not needed for header-based auth
          },
        });

        const data = await res.json();

        // ❌ Check for HTTP status code errors first (e.g., 401, 403)
        if (!res.ok) {
          console.error(
            `⚠️ Profile fetch failed with status ${res.status}:`,
            data.error
          );
          return navigate("/login");
        }

        if (!data || !data._id) {
          // Fallback check if the server returned 200 but no user data
          return navigate("/login");
        }

        // ✅ User is successfully verified! Do nothing and allow the component to render.
      } catch (error) {
        console.error("⚠️ Error verifying user authentication:", error);
        // On network failure or critical error, redirect to login
        navigate("/login");
      }
    };

    verifyUser();
  }, [navigate]);

  return null; // No UI — runs redirect logic silently
}
